
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/give-subscription/personalize",
      function () {
        return require("private-next-pages/give-subscription/personalize.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/give-subscription/personalize"])
      });
    }
  